/** Adresse éligible à la livraison à domicile (zone active associée). */
export function isAddressDeliverable(addr: {
  zoneId?: string | null;
  zone?: { id: string } | null;
}): boolean {
  return Boolean(addr.zoneId && addr.zone);
}

export const OUT_OF_DELIVERY_ZONE_MESSAGE =
  "Cette adresse n'est pas couverte par nos zones de livraison. Seul le retrait sur place est disponible.";
